import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Header from './Header';
import Sidebar from './Sidebar';

// Contenedor de la página
const PageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
`;

// Contenedor principal de la página
const MainContent = styled.main`
  flex: 1;
  margin-left: 250px;
  margin-top: 80px;
  padding: 2rem;
  overflow: auto;
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

// Variantes de animación para la transición de páginas
const pageVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  in: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -20
  }
};

// Transición de página
const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.5
};

// Props del componente Layout
interface LayoutProps {
  children: React.ReactNode;
}

// Componente Layout
const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <PageContainer>
      <Header />
      <Sidebar />
      <MainContent>
        <motion.div
          initial="initial"
          animate="in"
          exit="exit"
          variants={pageVariants}
          transition={pageTransition}
        >
          {children}
        </motion.div>
      </MainContent>
    </PageContainer>
  );
};

export default Layout; 